import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useLang } from '../lib/useLang'
import './Landing.css'
import './PublicPage.css'

export default function Plans() {
  const navigate = useNavigate()
  const { t } = useLang()

  const plans = t('plansPage.plans')
  const faqs = t('plansPage.faqs')

  useEffect(() => {
    window.scrollTo(0, 0)
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target) } }),
      { threshold: 0.08 }
    )
    document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [])

  return (
    <div className='public-page'>
      <Helmet>
        <title>Plans & Pricing — MODELLER</title>
        <meta name="description" content="Choose a plan that fits your needs. Free tier available. From raw data to production ML — no code required." />
      </Helmet>
      {/* Hero */}
      <div className='public-hero'>
        <div className='public-hero-inner'>
          <div data-reveal className='public-tag'>{t('plansPage.tag')}</div>
          <h1 data-reveal className='public-hero-title' style={{ transitionDelay: '0.1s' }}>
            {t('plansPage.title')}
          </h1>
          <p data-reveal className='public-hero-sub' style={{ transitionDelay: '0.2s' }}>
            {t('plansPage.subtitle')}
          </p>
        </div>
      </div>

      {/* Plans grid */}
      <div className='public-section-shimmer'>
        <div className='mx-auto max-w-6xl px-6 py-24'>
          <div className='grid gap-6 md:grid-cols-3'>
            {Array.isArray(plans) && plans.map((plan, i) => (
              <div
                key={plan.name}
                data-reveal
                className={`plans-card ${i === 1 ? 'plans-card-highlight' : ''}`}
                style={{ transitionDelay: `${i * 0.12}s` }}
              >
                {/* Badge */}
                <div className='plans-badge-row'>
                  {plan.badge.split(' · ').map((b, j) => (
                    <span key={j} className={`plans-badge ${b === t('settings.popular') ? 'plans-badge-popular' : ''}`}>{b}</span>
                  ))}
                </div>

                <h3 className='plans-name'>{plan.name}</h3>
                <p className='plans-desc'>{plan.description}</p>

                <div className='plans-price-row'>
                  <span className='plans-price'>{plan.price}</span>
                  <span className='plans-period'>{plan.period}</span>
                </div>

                <ul className='plans-features'>
                  {plan.features.map((f, j) => (
                    <li key={j} className='plans-feature'>
                      <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='plans-check'>
                        <path d='M20 6L9 17l-5-5' />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => navigate(i === 2 ? '/contact' : '/auth')}
                  className={i === 1 ? 'plans-cta-primary' : 'plans-cta-secondary'}
                >
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className='public-section-dark'>
        <div className='mx-auto max-w-3xl px-6 py-24'>
          <h2 data-reveal className='mb-14 text-center text-4xl font-light'>
            {t('plansPage.faqTitle')}
          </h2>
          <div className='space-y-6'>
            {Array.isArray(faqs) && faqs.map((faq, i) => (
              <div key={i} data-reveal className='faq-item' style={{ transitionDelay: `${i * 0.1}s` }}>
                <div className='faq-q'>{faq.q}</div>
                <div className='faq-a'>{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  )
}
